import styled from "styled-components"
import Divider from './assets/svgs/pattern-divider-desktop.svg'
import Dice from './assets/svgs/icon-dice.svg'
import { useState, useEffect } from "react"

const Div = styled.div`
width: 70%;
max-width: 400px;
margin: 200px auto;
border-radius: 15px;
background-color: hsl(217, 19%, 24%);
/* height: 250px; */
padding: 2rem 1rem;
position: relative;
display: flex;
flex-direction: column;
align-items: center;
@media(max-width: 550px){
    width: 90%;
}
`
const Header = styled.header`
font-size: 0.7rem;
font-weight: 400;
color: hsl(150, 100%, 66%);
text-transform: uppercase;
letter-spacing: 0.2rem;
`
const Divide = styled.img`
width: 90%;
position: absolute;
bottom: 20%;
/* margin-bottom: 5px; */
`

const Button = styled.button`
position: absolute;
background-color: #52ffa8;
height: 3.5rem;
width: 3.5rem;
border: none;
border-radius: 50%;
bottom: -2rem;
&:hover{
    box-shadow: 0 0 15px 5px #52ffa8;
}
&:active{
    box-shadow: 0 0 10px 5px #52ffa8;
}
`
const AdviceBody = styled.div`
padding: 0.5rem;
margin-bottom: 30px;
text-align: center;
font-size: 1rem;
/* @media(max-width: 350px){
    font-size: 0.8rem;
} */
`

const Advice = () => {

    const [advice, setAdvice] = useState(null);
    const [id, setId] = useState(null)

    function generateAdvice() {
        fetch('https://api.adviceslip.com/advice')
        .then(res => {
          return res.json()
        })
        .then(res => {
          setId('Advice #'+ res.slip.id)
          setAdvice(`${res.slip.advice}`)
        })
      }
    
    const dice = document.querySelector('#dice');
    const [roll, setRoll] = useState(false);
    function clickAnimate(){
        if(roll === false){
            dice.classList.remove("rolling-false");
            dice.classList.add("rolling-true");
            setRoll(true);
        } else if(roll === true){
            dice.classList.add("rolling-false");
            dice.classList.remove("rolling-true");
            setRoll(false);
        }
    }

    useEffect(
        ()=>(generateAdvice())
    )
  
  return (
    <Div>
         <Header id="adviceId">{id}</Header>
        <AdviceBody id="adviceBody">{advice}</AdviceBody>
        <Divide src={Divider} alt="divide" />
        <Button id="dice" data-roll={roll} onClick={()=>{generateAdvice(); clickAnimate();}}>
            <img src={Dice} alt="dice"/>
        </Button>
    </Div>
  )
}

export default Advice